import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styles: [
  ]
})
export class DashboardComponent implements OnInit {

 Hora:any;





  constructor(private router:Router,private activatedRoute:ActivatedRoute) { }

  ngOnInit(): void {
      const params = this.activatedRoute.snapshot.params;
    this.Hora=params.horaLogin;
    console.log(this.Hora);
  
    // console.log(this.inicioSesion);
    // console.log(this.finSesion);

  }


  listaversiones(){
    this.router.navigate(['/dashboard/paginaversiones']);
    // location.reload;
  }



 
    

}